export default __webpack_public_path__ + "static/media/smiley2-filled.069912f6.svg";